<template>
  <section :id="`section-${iterator}`" class="course-index">
    <span class="d-none">{{name}}</span>
    <main class="row col-lg-11 mx-auto px-0 margin-between bg-white border">
      <div
        class="col-lg-5 px-0 bg-image"
        :style="{ backgroundImage: `url('${getImageUrl(image)}')` }"
      >
        <div class="overlay-container" v-if="status === 'completed'">
          <div class="overlay"></div>
          <i class="fas fa-check-circle overlay-icon"></i>
        </div>
      </div>
      <span class="availablity availablity-mobile d-sm-block d-md-none">{{availablity}}</span>
      <div class="col-lg-7 d-flex align-items-center p-4">
        <section class="details w-100">
          <h3 class="font24 font-weight-bold text-small-center ma__font18">{{name}}</h3>
          <p class="font18 d-none d-md-block" v-html="description"></p>
          <span class="availablity d-none d-md-table">{{availablity}}</span>
          <div
            class="float-right positioned-button d-none d-md-block"
            :class="`viewcourses-${iterator}`"
          >
            <div class="d-flex align-items-center">
              <a
                data-toggle="collapse"
                :href="`#main${iterator}`"
                aria-expanded="false"
                :data-title="name.toLowerCase()"
                data-event="collapse"
                data-action="open"
                data-name="onclick"
                data-type="click"
                data-region="main content"
                :data-section="name.toLowerCase()"
                data-text="view course details"
                :data-attribute="`section-${iterator}`"
                :aria-controls="`main${iterator}`"
                class="mr-4 link-class-bb"
                @click="hideShowCourses(iterator)"
              >View course details</a>
              <BaseButtons
                :courseTitle = name
                :url="url"
                :listing_id= "listing_id"
                :courseStatus="courseStatus"
                :status="status"
                :isAuthenticted="isAuthenticated"
                :Userstatus="currentUser.user.status"
                :course_id="course_id"
              />
            </div>
          </div>
          <div
            class="mt-4 d-sm-block d-md-none text-center ma__blocklink"
            :class="`viewcourses-${iterator}`"
          >
            <a
              data-toggle="collapse"
              :href="`#main${iterator}`"
              :data-attribute="`section-${iterator}`"
              aria-expanded="false"
              :aria-controls="`main${iterator}`"
              class="mb-3 link-class-bb d-block"
              @click="hideShowCourses(iterator)"
              :data-title="name"
            >View course details</a>
            <BaseButtons
                :courseTitle = name
                :listing_id= "listing_id"
                :url="url"
                :courseStatus="courseStatus"
                :status="status"
                :isAuthenticted="isAuthenticated"
                :Userstatus="currentUser.user.status"
                :course_id="course_id"
            />
          </div>
        </section>
      </div>
      <section
        class="col-sm-10 mx-auto collapse"
        :id="`main${iterator}`"
        role="tabpanel"
        :aria-labelledby="`heading${iterator}`"
      >
        <span class="mt-64 mb-64 bg-dark d-block" style="padding: 1px; width:100%"></span>
        <article class="course-desc mb-64">
          <h3 class="font24 font-weight-bold">Course description</h3>
          <p class="font16" v-html="full_description"></p>
        </article>
        <article class="course-desc mb-64">
          <h3 class="font24 font-weight-bold">Course objectives</h3>
          <ul class="objectives-list pl-3">
            <li
              class="objectives-item mb-2"
              v-for="(objective,i) in objectives"
              :key="i"
            >{{objective}}</li>
          </ul>
        </article>
        <article class="course-desc mb-64">
          <h3 class="font24 font-weight-bold">Course outline</h3>
          <div class="container">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <template v-for="(outlines,i) in outline">
                <collapse-component
                  v-if="(outlines.topic || {}).length > 0"
                  :key="i"
                  :id="course_id"
                  :heading="outlines.module"
                  :description="outlines.topic"
                  :iteration="i"
                  :name="name"
                />
                <article class="panel panel-default" :key="i" v-else>
                  <dd class="panel-heading" role="tab">
                    <h4 class="panel-title m-0 font18">
                      <a class="link-class" v-html="outlines.module"></a>
                    </h4>
                  </dd>
                </article>
              </template>
            </div>
          </div>
          <aside v-if="warning" class="bg-gray d-sm-block d-lg-none col-lg-8 shadow-sm mx-auto">
            <div class="row flex-nowrap">
              <div class="col-sm-3" style="max-width:20%">
                <span class="circle-border p-2">
                  <img
                    src="../assets/images/file-alt-solid.svg"
                    alt="File image"
                    class="image-icons"
                  />
                </span>
              </div>
              <div class="col-sm-9" v-html="courseSection"></div>
            </div>
          </aside>
          <div v-if="proof" class="text-center font-weight-bold mt-1 pt-5">{{proof[0].description}}</div>
          <div class="text-center mt-5 pt-5">
            <a
              data-toggle="collapse"
              data-event="collapse"
                data-action="close"
                data-name="onclick"
                data-type="click"
                data-region="main content"
                :data-section="name.toLowerCase()"
                data-text="hide course details"
              :href="`#main${iterator}`"
              :data-title="name.toLowerCase()"
              :data-attribute="`section-${iterator}`"
              aria-expanded="false"
              :aria-controls="`main${iterator}`"
              class="mx-2 mb-5 link-class-bb"
              @click="CloseSelecedCourses(iterator)"
            >Hide course details</a>
            <br />
            <div class="mt-4">
              <BaseButtons
                :courseTitle = name
                :url="url"
                :listing_id= "listing_id"
                :courseStatus="courseStatus"
                :status="status"
                :isAuthenticted="isAuthenticated"
                :Userstatus="currentUser.user.status"
                :course_id="course_id"
              />
            </div>
          </div>
        </article>
      </section>
    </main>
  </section>
</template>

<script>
import collapseComponent from "../components/collapseCoponent";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      courseStatus: {
        available: {
          display: "Enroll in this course",
          button: "btn btn-secondary"
        },
        active: {
          display: "Resume course",
          button: "btn btn-primary"
        },
        completed: {
          display: "Review course",
          button: "btn btn-default"
        }
      },
      courseSection: ''
    };
  },
  components: {
    collapseComponent
  },
  props: {
    name: String,
    image: String,
    link: String,
    description: String,
    status: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    course_id: {
      type: String
    },
    listing_id: {
      type: String
    },
    full_description: {
      type: String
    },
    availablity: {
      type: String,
      default: ""
    },
    objectives: {
      type: Array,
      default: ""
    },
    outline: {
      type: Array
    },
    proof:{
      type:Array
    },
    iterator: {
      type: Number
    },
    warning: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  mounted(){
    if(this.warning){
      this.courseSection = this.warning.description.replace('$dataSection$',this.name.toLowerCase());
    }
  },
  methods: {
    getImageUrl(image) {
      return require(`../assets/images/${image}`);
    },
    hideShowCourses(iterator) {
      $(`.viewcourses-${iterator}`).addClass("visibilityCourse");
      utag.link({
        event:'collapse',
        action:'open',
        name:'onclick',
        type:'click',
        region:'main content',
        section:this.name.toLowerCase(),
        text:'view course details',
        tealium_event:'collapse_open'
      })
    },
    CloseSelecedCourses(iterator) {
      $(`.viewcourses-${iterator}`).removeClass("visibilityCourse");
      utag.link({
        event:'collapse',
        action:'close',
        name:'onclick',
        type:'click',
        region:'main content',
        section:this.name.toLowerCase(),
        text:'hide course details',
        tealium_event:'collapse_close'
      })
      // $([document.documentElement, document.body]).animate({
      //   scrollTop: $(`#section-${iterator}`).offset().top
      // }, 50)
     
      let offsetTop = $(`#section-${iterator}`).offset().top
      window.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style>
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.details {
  padding: 32px 0;
}

.availablity {
  background-color: black;
  color: white;
  padding: 5px;
}

.bg-image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 40%;
  min-width: 350px;
  overflow: hidden;
}

.course-index {
  text-decoration: none;
  color: black;
  overflow: hidden;
}

.availablity-mobile {
  position: relative;
  margin: 0 auto;
  margin-top: -1rem !important;
}

.course-index:hover {
  text-decoration: none;
  color: black;
}

.withPadding64 {
  margin: 64px 0;
}

.overlay-icon {
  position: absolute;
  left: 33%;
  top: 35%;
  font-size: 90px;
  z-index: 2;
  color: white;
}

@media (max-width: 554px) {
  .bg-image {
    height: 250px !important;
    background-position-y: 30%;
  }
}

@media (max-width: 900px) {
  .bg-image {
    height: 350px;
    background-position-y: 30%;
  }

  .details {
    padding: 0px 0;
  }
}
.visibilityCourse {
  visibility: hidden;
  height: 0;
  width: 0;
}
</style>